import Button from '../../reusable/Button/Button';
import Skeleton from '../../reusable/Skeleton/Skeleton';
import { t } from '../../i18n/i18n';
import { useGetCTraderLaunchUrlQuery } from '../../store/api/platformApi';
import './CTrader.scss';

/**
 * cTrader Web inside the dashboard — N80, live's `/ctrader` (`pages/CTrader`
 * on main). The back end signs the trader into cTrader Web and answers with
 * where that session lives; the page frames it at the full size of the shell,
 * since it's a whole trading terminal and not a widget.
 *
 * Reached from "Launch cTrader" in the nav, which only cTrader clients see
 * (`gate: 'ctrader'`, useNavGates). The URL is a fresh signed session each
 * visit — never served from cache (see platformApi).
 */
export default function CTrader() {
  const { data: url, isFetching, isError, refetch } = useGetCTraderLaunchUrlQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (isFetching) {
    return (
      <div className="ctrader ctrader--state" aria-busy="true">
        <Skeleton w="100%" h="100%" radius="var(--r-card)" />
      </div>
    );
  }

  if (isError || !url) {
    return (
      <div className="ctrader ctrader--state">
        <div className="ctrader__message" role="alert">
          <p className="ctrader__title">{t('cTrader couldn’t be opened')}</p>
          <p className="ctrader__text">
            {t('Your cTrader session didn’t start. Try again — if it keeps happening, contact support.')}
          </p>
          <Button variant="pill" height={32} paddingInline={16} onClick={refetch}>
            {t('Try again')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="ctrader">
      <iframe
        className="ctrader__frame"
        src={url}
        title="cTrader"
        allow="clipboard-read; clipboard-write; fullscreen"
        allowFullScreen
      />
    </div>
  );
}
